export default {
  site: {
    title: "Chengdu Huanyu Zongheng International Travel Service Co., Ltd.",
  },
  lang: {
    switch: "中文",
    zh: "中文",
    en: "English",
  },
  header: {
    phone: "15114070473",
    email: "hz@pangod.com",
  },
  search: {
    placeholder: "Search destinations...",
    submit: "Search",
    title: "Destination Search",
    enterKeyword: "Enter a destination or city to search",
    noResults: "No destinations found. Try a different keyword.",
    resultCount: '{count} result(s) for "{q}"',
    types: {
      page: "Page",
      destination: "Destination",
      guide: "Travel Service",
      strategy: "Travel Tips",
      banner: "Featured",
    },
  },
  nav: {
    home: "Home",
    planTrip: "Plan My Trip",
    destinations: "Destinations",
    travelThemes: "Travel Themes",
    testimonials: "Testimonials",
    contact: "Contact Us",
    about: "About Us",
    destSichuan: "Sichuan",
    destChongqing: "Chongqing",
    destBeijing: "Beijing",
    destXian: "Xi'an",
    guide: "Travel Guide",
    strategy: "Travel Tips",
    bcfw: "Charter Service",
    cjly: "Hotel Booking",
    gnly: "Ticket Booking",
    qydz: "Chinese Flavors",
    qzbl: "Visa Service",
    srdz: "Themed Travel",
  },
  planTrip: {
    title: "Plan My Trip",
    en: "PLAN MY TRIP",
    heroTitle: "Customized Travel",
    heroEn: "Tailored Journeys",
    steps: [
      { title: "Submit Request" },
      { title: "Get Your Plan" },
      { title: "Confirm Itinerary" },
      { title: "Sign & Go" },
    ],
    cta: "Start Planning",
    servicesTitle: "What We Offer",
    services: [
      {
        title: "Fully Personalized",
        desc: "Built around your preferences—where to go and how to explore is entirely up to you.",
      },
      {
        title: "Expert Planners",
        desc: "100+ specialists with thousands of trips each—they know the destinations and understand you.",
      },
      {
        title: "Free Itinerary Draft",
        desc: "Professional route advice at no cost—confidence for independent travel, without the guesswork.",
      },
      {
        title: "One-Stop Service",
        desc: "No research, hotel comparisons, or driver coordination—we handle it all; you just depart.",
      },
    ],
  },
  footer: {
    companyName:
      "Company: Chengdu Huanyu Zongheng International Travel Service Co., Ltd.",
    phone: "Phone: 15114070473",
    address:
      "Address: 37F, Building 2, No. 318 Dongda Road, Jinjiang District, Chengdu, Sichuan",
    copyright:
      "© Chengdu Huanyu Zongheng International Travel Service Co., Ltd. All rights reserved.",
  },
  common: {
    backTop: "Back to Top",
    home: "Home",
    publishedAt: "Published: ",
  },
  home: {
    banner: [
      {
        tag: "Roam Around China",
        title: "SICHUAN",
        sub: "A picturesque land of abundance, gathering stunning natural scenery and laid-back Bashu charm",
      },
      {
        tag: "Roam Around China",
        title: "CHONGQING",
        sub: "A dynamic river city embraced by mountains, featuring magnificent terrains and rich local customs",
      },
      {
        tag: "Roam Around China",
        title: "BEIJING",
        sub: "An ancient capital with profound heritage, boasting grand imperial style and modern charm",
      },
      {
        tag: "Roam Around China",
        title: "XIAN",
        sub: "A time-honored historic city, bearing splendid ancient culture and peaceful ancient town vibes",
      },
    ],
    about: {
      title: "About Us",
      en: "ABOUT US",
      desc: "Founded in 2019, Huanji Yiyou is a professional travel operator dedicated to high-quality, personalized services for global clients, with a strong reputation built through steady growth.",
    },
    enjoy: {
      en: "ENJOY ONESELF",
      title: "Choose Our Best Travel Destinations",

      ratingLabel: "Rating",
      destinations: [
        {
          tourName:
            "6-Day Jiuzhai, Huanglong & Dujiangyan In-Depth Custom Tour",
          location: "Chengdu, Sichuan",
          rating: "4.9",
        },
        {
          tourName: "Sichuan-Chongqing Twin Cities · 9-Day Luxury Tour",
          location: "Chengdu, Sichuan + Chongqing",
          rating: "4.9",
        },
        {
          tourName: "7-Day 6-Night Beijing Private Custom Tour",
          location: "Beijing",
          rating: "4.9",
        },
        {
          tourName: "Meet Chang'an · 6-Day 5-Night Xi'an Private Custom Tour",
          location: "Xi'an",
          rating: "4.9",
        },
      ],
    },
    travelGuide: {
      title: "One-Stop Service",
      en: "ONE-STOP SERVICE",
      items: {
        bcfw: {
          title: "Charter Service",
          desc: "Private car travel with flexible stops. Multiple vehicle options and professional guide-drivers throughout. Thoughtful service for a worry-free journey.",
        },
        cjly: {
          title: "Hotel Booking",
          desc: "Curated Aman, Four Seasons, Ritz-Carlton and more—matched to your budget and needs. Just check in.",
        },
        qzbl: {
          title: "Visa Service",
          desc: "One-on-one expert guidance from application to approval—we handle the hassle, you prepare to depart.",
        },
        gnly: {
          title: "Ticket Booking",
          desc: "Lock popular attraction tickets early—even the hardest bookings. Tickets in hand, travel anytime.",
        },
        qydz: {
          title: "Chinese Flavors",
          desc: "Authentic Chinese cuisine reserved for you—top restaurants booked ahead, every meal arranged.",
        },
        srdz: {
          title: "Themed Travel",
          desc: "Tailored to your interests with on-the-ground routes—deep immersion, not rushed sightseeing.",
        },
      },
    },
    whyChoose: {
      en: "WHY CHOOSE US",
      title: "Why Choose Huanji",
      items: [
        {
          title: "Pure Play No Shopping",
          desc: "Every route is built around comfort and authentic experiences—no gimmicks, no shopping stops. Enjoy local culture, scenery, and stories with peace of mind for a more meaningful, worry-free journey.",
        },
        {
          title: "Tailored Service Thoughtful Care",
          desc: "Based on your schedule, interests, and budget—whether families, couples, or corporate teams—we communicate closely with you to craft a personalized plan that fits your style and budget, from modest to premium.",
        },
        {
          title: "From Crowds to Private—All Welcome",
          desc: "From day trips to boutique small groups, family holidays to corporate inspections—we offer many travel formats. Whatever your goals or preferences, we have the right product for you.",
        },
        {
          title: "Local Roots Direct Resources",
          desc: "As a locally rooted agency with first-hand resources, we deliver strong value. Local guides, licensed vehicles, and vetted hotels ensure safety, quality, and comfort throughout your journey.",
        },
      ],
    },
    reviews: {
      en: "CUSTOMER REVIEWS",
      title: "China Travel Customer Reviews & Experiences",
      intro:
        "At Huanji Yiyou, we are dedicated to creating unforgettable journeys for every traveler. Read firsthand accounts from visitors around the world and discover their authentic experiences traveling in China.",
      platforms: [
        {
          id: "facebook",
          name: "Facebook",
          ratingLabel: "Excellent",
          starTheme: "orange",
          reviews: [
            {
              author: "Customer from Singapore",
              date: "January 2026",
              rating: 5,
              title: "",
              content:
                "A very comfortable journey—big praise for our guide Xiao Liu! Traveling with two elderly family members, he thoughtfully handled everything so we didn't have to worry at all. The hotel was excellent with views of Xi'an's city wall, a large room, a bathtub, and a hearty breakfast. He chose a less crowded time for the Terracotta Warriors so we could easily see the full pits from the railing with a great explanation—beyond expectations! Eternal Regret is a must-see—the live performance and visuals can't be captured on a phone. Legend of the Camel Bell was wonderful too. An extremely satisfying and pleasant trip!",
            },
          ],
        },
        {
          id: "instagram",
          name: "Instagram",
          ratingLabel: "Excellent",
          starTheme: "orange",
          reviews: [
            {
              author: "Customer from Hong Kong",
              date: "January 2026",
              rating: 5,
              title: "",
              content:
                "I brought my parents to Beijing to fulfill their wish to see the capital. We were lucky to meet Guide Yang—a warm, responsible local Beijinger. The planner communicated each day's itinerary in advance with detailed explanations at every site. Yang also took many photos for us. The whole family is very satisfied—five stars. We'll choose you again, and recommend you first to friends.",
            },
          ],
        },
        {
          id: "tiktok",
          name: "TikTok",
          ratingLabel: "Excellent",
          starTheme: "orange",
          reviews: [
            {
              author: "Customer from Malaysia",
              date: "January 2026",
              rating: 5,
              title: "",
              content:
                "A trip to China with good friends—we chose their custom tour because the place was unfamiliar. The planner adjusted the itinerary three times to our needs. We saw giant pandas, Jiuzhai Valley, and Huanglong's Five-Colored Ponds—unexpectedly beautiful. Unlike Tiffany blue in Kanas, Jiuzhai was deep mysterious blue; Huanglong mixed blues like a fairyland, plus jelly-blue ice waterfalls. Off-season meant fewer crowds but scenery was already stunning—June to October might be even better; hope to bring parents someday. Great food, stays, and fun; visiting a Tibetan home we felt hearty eating, drinking, and talking freely. Thanks to planner Xiao Chen and our humorous, dedicated guide—service was excellent!",
            },
          ],
        },
      ],
    },
    contactForm: {
      title: "Contact Us",
      subtitle: "Huanji Yiyou—explore China together with you",
      email: "Email: hz@pangod.com",
      whatsapp: "WhatsApp/Tel: 15114070473",
      namePlaceholder: "Your Name*",
      emailPlaceholder: "Email Address*",
      phonePlaceholder: "Phone Number",
      messagePlaceholder: "Your Message*",
      submit: "Submit",
      submitArrow: "→",
      submitHint: "Get free travel guide",
      required: "Please fill in required fields",
      submitSuccess: "Submitted successfully. We will contact you soon!",
      submitFail: "Submission failed. Please try again later",
    },
  },
  about: {
    title: "About Us",
    en: "ABOUT US",
    p1Highlight: "Huanji Yiyou",
    p1Text:
      ", founded in 2019, is a professional travel operator dedicated to high-quality, personalized travel services for global clients. Through steady development, the company has built a strong reputation and brand image in the industry.",
    p2Title: "Core Business",
    p2Highlight: "Core business",
    p2Text:
      "Covers customized travel, group tours, and business visits at home and abroad. We focus on customer needs and provide one-stop, personalized travel solutions. In premium custom travel especially, our experienced planners and rigorous service deliver unique journeys for every client.",
    p2Prefix: "",
    p3Title: "Group Company",
    p3Highlight: "Pangu Zongheng Group Co., Ltd.",
    p3Text:
      "Huanji Yiyou is part of Pangu Zongheng Group Co., Ltd. Originating from Chengdu Pangu Network Co., Ltd. (2003) and headquartered in Chengdu, the group integrates independent operations and investment incubation, with a presence in Sichuan, Chongqing, Shanxi, Gansu, Beijing, Japan, and more. Its businesses include advertising, technology, finance, branding, Japan hotel operations, and cross-border travel, having incubated brands such as Pangu Advertising, Pangu Information, Fudu Pawn, Hongjun Brand Management, Japan Pangoo Hotel, and Huanji Yiyou.",
    p3Prefix: "",
    stats: {
      years: " yrs",
      yearsLabel: "Years of Experience",
      services: "",
      servicesLabel: "Leisure Services",
      team: "Professional Team",
      satisfaction: "Customer Satisfaction",
    },
    culture: {
      title: "Our Culture",
      en: "CULTURE",
      items: [
        {
          title: "Philosophy",
          en: "PHILOSOPHY",
          desc: "Bring you closer to nature with attentive services and modern leisure facilities for true relaxation.",
        },
        {
          title: "Our Vision",
          en: "OUR VISION",
          desc: "Bring you closer to nature with attentive services and modern leisure facilities for true relaxation.",
        },
        {
          title: "Our Mission",
          en: "OUR MISSION",
          desc: "Bring you closer to nature with attentive services and modern leisure facilities for true relaxation.",
        },
      ],
    },
  },
  contact: {
    title: "Contact Us",
    en: "CONTACT US",
    companyName:
      "Company: Chengdu Huanyu Zongheng International Travel Service Co., Ltd.",
    phone: "Phone: 15114070473",
    address:
      "Address: 37F, Building 2, No. 318 Dongda Road, Jinjiang District, Chengdu, Sichuan",
  },
  destinationRegion: {
    sectionLabel: "FEATURED TOURS",
    sectionTitle: "Featured Tours in {region}",
    regions: {
      sichuan: {
        tag: "Roam Around China",
        title: "Sichuan",
        sub: "A picturesque land of abundance, gathering stunning natural scenery and laid-back Bashu charm",
      },
      chongqing: {
        tag: "Roam Around China",
        title: "Chongqing",
        sub: "A dynamic river city embraced by mountains, featuring magnificent terrains and rich local customs",
      },
      beijing: {
        tag: "Roam Around China",
        title: "Beijing",
        sub: "An ancient capital with imperial grandeur and a cosmopolitan spirit",
      },
      xian: {
        tag: "Roam Around China",
        title: "Xi'an",
        sub: "A historic city where Qin, Han, and Tang heritage meets vibrant street life",
      },
    },
  },
  destinationDetail: {
    buyNow: "Buy Now >>>",
    bookTour: "Book this Tour",
    bookContact: "Questions? Call / WhatsApp: 15114070473",
    labels: {
      tourCode: "Tour Code",
      time: "Duration",
      cities: "Cities",
      accommodation: "Accommodation",
      hotel: "Hotel",
      meals: "Meals",
    },
    highlightsTitle: "Trip Highlights",
    feeTitle: "Fees",
    feeIncludedLabel: "Included",
    feeExcludedLabel: "Not Included",
    feeRemarksLabel: "Notes & Others",
    photosTitle: "Our Photos",
    photoTabs: {
      all: "All",
      hotel: "Partner Hotels",
      vehicle: "Tour Vehicles",
      office: "Company Environment",
      team: "Staff Group Photos",
    },
    list: [
      {
        heroTag: "Explore Sichuan",
        heroTitle: "Land of Abundance · Charming Sichuan",
        tourTitle:
          "Jiuzhai + Huanglong + Dujiangyan + Panda Valley | Sichuan Panorama Custom Tour",
        tourRoute:
          "6 Days 5 Nights | Chengdu · Dujiangyan · Panda Valley · Huanglong · Jiuzhai",
        tourDesc: "",
        tourCode: "CT-SC-JZG-06",
        tourDays: "6 Days",
        tourCities: "Chengdu-Dujiangyan-Huanglong-Jiuzhai",
        tourAccommodation:
          "Jinglan Qingtang / Xizi Libai Jiuzhai / Gongxili, etc.",
        highlights: [
          "1-on-1 customization: dedicated senior team throughout",
          "Premium transport: luxury business vehicle, private travel",
          "Curated stays: quality hotels + themed experiences",
          "In-depth experiences: unlock local hidden gems",
          "Chinese guide-driver: professional, zero language barrier",
          "Pure play guarantee: licensed operator, no shopping stops",
          "Worry-free service: one-stop planning, truly hassle-free",
        ],
        days: [
          {
            title: "Day 1 | Arrive in Chengdu · First Taste of City Life",
            hotel: "Jinglan Qingtang",
            route: "",
            meals: "",
            paragraphs: [
              "Private pickup from Chengdu Shuangliu Airport, Tianfu Airport, or Chengdu East Station—no dragging luggage to find a ride.",
              "Head straight to top districts: Chunxi Road, IFS panda, Taikoo Li—eat, shop, and shoot stylish photos. At night, try rabbit heads and ice jelly and feel Chengdu's laid-back vibe.",
            ],
          },
          {
            title:
              "Day 2 | Dujiangyan + Panda Valley · Full of Healing Moments",
            hotel: "Jinglan Qingtang",
            route: "",
            meals: "",
            paragraphs: [
              "Morning at Panda Valley—meet red pandas and giant pandas among bamboo and streams.",
              "Afternoon at Dujiangyan: Fish Mouth, Flying Sand Weir, ancient irrigation wisdom.",
              'Evening in ancient Guanxian town, night walk on Nanqiao for the "blue tears" glow on the Min River. Don\'t miss the giant panda at Yangtianwo Square for great photos.',
            ],
          },
          {
            title: "Day 3 | To Huanglong · Fairyland on Earth",
            hotel: "Xizi Libai Jiuzhai",
            route: "",
            meals: "",
            paragraphs: [
              "High-speed rail from Chengdu East to Huanglong Jiuzhai Station with plateau scenery along the way.",
              "🏔Visit 5A Huanglong Scenic Area—cable car up for comfort. Five-Colored Ponds shine in blue-green layers like a spilled palette.",
              "Overnight near Jiuzhai Valley entrance to rest for tomorrow's fairy-tale waters.",
            ],
          },
          {
            title: "Day 4 | Jiuzhai Valley Full Day · Into a Water Fairy Tale",
            hotel: "Xizi Libai Jiuzhai",
            route: "",
            meals: "",
            paragraphs: [
              "A full day in Jiuzhai Valley—three branches of the Y-shaped valley, villages and snow peaks, every frame like a movie🎬.",
              "Easy pace for seniors and kids: Five Flower Lake, Pearl Shoals, Reed Lake—wallpaper shots everywhere.",
              "You'll understand why they say: after Jiuzhai, no other water compares.",
            ],
          },
          {
            title: "Day 5 | Slow Chengdu Life · Old City In Depth",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "Morning at Heming Teahouse in People's Park—tea and ear cleaning, the ultimate slow-life experience.",
              "Afternoon at Wide & Narrow Alleys and Du Fu Thatched Cottage—bamboo, poetry, classic photo spots.",
              'Evening at Eastern Suburb Memory for the Hanfu banquet show "Shu Yan Fu"—dining with immersive performance.',
            ],
          },
          {
            title: "Day 6 | Wuhou Shrine + Departure · Three Kingdoms Finale",
            hotel: "Gongxili",
            route: "",
            meals: "",
            paragraphs: [
              "Morning at Wuhou Shrine—red walls and bamboo, Three Kingdoms history. Next door, Jinli Ancient Street lanterns and Sichuan street food.",
              "Afternoon private transfer to the airport—a relaxed farewell to your journey.",
            ],
          },
        ],
        feeIncluded:
          "Attraction tickets, hotels, meals, guide, and private transport listed in the itinerary.",
        feeExcluded:
          "International/domestic flights and taxes, personal travel/medical insurance, visa fees, personal expenses, and extra costs due to force majeure (flight delays, natural disasters, war, etc.).",
      },
      {
        heroTag: "",
        heroTitle: "Sichuan-Chongqing Twin Cities · 9-Day Luxury Tour",
        tourTitle:
          "Sichuan-Chongqing Twin Cities · 9-Day Luxury Tour | Giant Pandas · Spicy Hotpot · 8D Magic Chongqing",
        tourRoute:
          "9 Days 8 Nights | Chengdu · Jiuzhai · Dujiangyan · Chongqing · Wulong",
        tourCode: "CT-SC-CQ-09",
        tourDays: "9 Days",
        tourCities: "Chengdu-Jiuzhai-Dujiangyan-Chongqing-Wulong",
        tourAccommodation:
          "Tonino Lamborghini/Jinlong International/Wyndham/Howard Johnson/Sheraton, etc.",
        highlights: [
          "1-on-1 customization: dedicated senior team throughout",
          "Premium transport: luxury business vehicle, private travel",
          "Curated stays: quality hotels + themed experiences",
          "In-depth experiences: unlock local hidden gems",
          "Chinese guide-driver: professional, zero language barrier",
          "Pure play guarantee: licensed operator, no shopping stops",
          "Worry-free service: one-stop planning, truly hassle-free",
        ],
        days: [
          {
            title: "Day 1 | Arrive in Chengdu · First Taste of City Life",
            hotel: "Tonino Lamborghini Hotel Chengdu",
            route: "",
            meals: "",
            paragraphs: [
              "Private pickup from Chengdu Shuangliu Airport, Tianfu Airport, or Chengdu East Station—no dragging luggage to find a ride.",
              "Head straight to top districts: Chunxi Road, IFS panda, Taikoo Li—eat, shop, and shoot stylish photos. At night, try rabbit heads and ice jelly and feel Chengdu's laid-back vibe.",
            ],
          },
          {
            title: "Day 2 | Chengdu - Panda Valley - To Jiuzhai",
            hotel: "Jinlong International Resort Hotel Jiuzhai",
            route: "",
            meals: "",
            paragraphs: [
              "Morning | Panda Valley: Step into a bamboo-shaded eco sanctuary and observe giant pandas up close. Streams, greenery, and healing photos everywhere.",
              "Afternoon | To Jiuzhai—drive north along the famous Jiuzhai loop road through the western Sichuan plateau. Snow peaks and meadows accompany you to this fairyland on earth.",
            ],
          },
          {
            title: "Day 3 | Jiuzhai Valley Full Day",
            hotel: "Jinlong International Resort Hotel Jiuzhai",
            route: "",
            meals: "",
            paragraphs: [
              "A full day in Jiuzhai Valley. The park forms a Y-shape; we visit Shuzheng Valley, Nuorilang Falls, Five Flower Lake, Pearl Shoals, Long Lake, Five-Colored Pond, and more.",
              "Turquoise lakes, layered waterfalls, colorful forests and snow peaks—every step is a masterpiece.",
            ],
          },
          {
            title: "Day 4 | Jiuzhai - Tibetan Street - Chuanzhusi",
            hotel: "Wyndham Chuanzhusi Songpan",
            route: "",
            meals: "",
            paragraphs: [
              "Morning at the Tibetan culture street—handicrafts and local culture. Then visit Chuanzhusi Monastery for peace among prayer flags.",
              "Afternoon coach via Songpan and Maoxian along the Min River canyon to Dujiangyan, birthplace of ancient irrigation wisdom.",
            ],
          },
          {
            title: "Day 5 | Dujiangyan - Chengdu - Chongqing",
            hotel: "Howard Johnson Qingcheng International",
            route: "",
            meals: "",
            paragraphs: [
              "Morning at Dujiangyan Irrigation Project—Fish Mouth, Flying Sand Weir, and Bottle-Neck Inlet showcase 2,000-year-old water management.",
              "Afternoon return to Chengdu, then high-speed rail to mountain city Chongqing for a new urban adventure.",
            ],
          },
          {
            title: "Day 6 | Wulong Tiankeng Three Bridges - Fairy Mountain",
            hotel: "Four Points by Sheraton Chongqing",
            route: "",
            meals: "",
            paragraphs: [
              "Morning at Wulong Tiankeng Three Bridges UNESCO site—film location for Transformers. Walk beneath Tianlong, Qinglong, and Heilong natural bridges.",
              'Afternoon at Fairy Mountain National Forest Park—the "Oriental Switzerland" with meadows, forest, and alpine scenery.',
            ],
          },
          {
            title:
              "Day 7 | Wujiang Gallery - Jiuli City / Gongtan Ancient Town",
            hotel: "Hash International Hotel Wulong",
            route: "",
            meals: "",
            paragraphs: [
              "Morning drive to Wulong with views of Wujiang Gallery—poetic landscapes along the river.",
              "Optional Jiuli City (Miao culture) or Gongtan Ancient Town (riverside heritage) for southeastern Chongqing charm.",
            ],
          },
          {
            title: "Day 8 | Liziba - Ciqikou - Hongyadong",
            hotel: "Four Points by Sheraton Chongqing",
            route: "",
            meals: "",
            paragraphs: [
              "Morning at Liziba Viewpoint for the iconic train-through-building scene, then Jiefangbei Pedestrian Street.",
              "Afternoon at Ciqikou Ancient Town and Hongyadong—stilt houses lit up at night like a real-life Spirited Away.",
            ],
          },
          {
            title: "Day 9 | Chongqing · Departure",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "Private transfer to Chongqing Jiangbei International Airport or railway station according to your schedule—a perfect end to your twin-city journey.",
            ],
          },
        ],
        feeIncluded:
          "Attraction tickets, hotels, meals, guide, and private transport listed in the itinerary.",
        feeExcluded:
          "International/domestic flights and taxes, personal travel/medical insurance, visa fees, personal expenses, and extra costs due to force majeure (flight delays, natural disasters, war, etc.).",
        feeRemarks: [
          "This itinerary is for reference during pre-trip planning only. Final itinerary and services are subject to our official Travel Confirmation Letter.",
          "If hotels are requisitioned due to force majeure, we will replace with same or higher standard properties. Final hotels are as stated on the official itinerary.",
        ],
      },
      {
        heroTag: "",
        heroTitle: "7-Day 6-Night Beijing Private Custom Tour",
        tourTitle: "Seven Nights of Beijing Charm · Past and Present",
        tourDesc:
          '7-Day 6-Night Beijing Private Tour · "From Flag-Raising to Hutong Homecoming"',
        tourRoute:
          "7 Days 6 Nights | Tiananmen · Forbidden City · Great Wall · Summer Palace · Hutongs",
        tourCode: "CT-BJ-07",
        tourDays: "7 Days",
        tourCities: "Beijing",
        tourAccommodation:
          "Guohong Hotel/Qianmen area/Olympic Park area/siheyuan hotels, etc.",
        highlights: [
          "1-on-1 customization: dedicated senior team throughout",
          "Premium transport: luxury business vehicle, private travel",
          "Curated stays: quality hotels + themed experiences",
          "In-depth experiences: unlock local hidden gems",
          "Chinese guide-driver: professional, zero language barrier",
          "Pure play guarantee: licensed operator, no shopping stops",
          "Worry-free service: one-stop planning, truly hassle-free",
        ],
        days: [
          {
            title: "Day 1 | Arrive in Beijing · Private Pickup · Free Time",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "Welcome to the capital. Private airport pickup saves hassle. After check-in, explore nearby areas like Xidan or Wangfujing at your own pace to settle in for the days ahead.",
              "[Stay Tip] Guohong Hotel or Qianmen area is ideal for an early start to the flag-raising ceremony tomorrow. Foreign guests must bring passports for hotel registration.",
            ],
          },
          {
            title:
              "Day 2 | Flag-Raising · Temple of Heaven · Forbidden City · Yangmeizhu Alley",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "[Stay Tip] Stay near Qianmen/Tiananmen again for easy walks back; or try a siheyuan hotel near Shichahai (e.g. Rosewood Shichahai) for old Beijing atmosphere.",
              "Before dawn, head to Tiananmen Square. Watch the flag rise with the sun—a quiet, powerful start to the day in China.",
              "Then Temple of Heaven. The blue roof of the Hall of Prayer is stunning. Clap at the Echo Wall and hear the sound travel along the curve.",
              "Midday at the Forbidden City. Walk from Meridian Gate to Gate of Divine Prowess—Hall of Supreme Harmony, Palace of Heavenly Purity, Imperial Garden. The square before the hall is vast. Treasures in the gallery are exquisite.",
              "Evening on Yangmeizhu Xiejie—a quiet hutong full of local life: stoves, pigeons, laundry lines. Find a café on the second floor and watch grey rooftops stretch into the distance.",
              "From solemn ceremony to everyday hutong—you see two sides of Beijing in one day.",
            ],
          },
          {
            title:
              "Day 3 | Mutianyu Great Wall · Olympic Park · Bird's Nest · Water Cube",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "[Stay Tip] Olympic Park area (e.g. InterContinental Beijing Beichen) for easy return after the evening lights; or Guohong Hotel in the city (~40 min drive).",
              "Morning at Mutianyu Great Wall—fewer crowds than Badaling, sweeping views. Cable car up, walk the wall like a dragon along the ridge. Slide down through the forest—fun for all ages.",
              "Afternoon at Olympic Park. Bird's Nest steel weave, Water Cube like blue bubbles in sunlight. At dusk, lights turn Bird's Nest warm red and Water Cube deep blue—perfect for photos side by side.",
              "From ancient fortification to modern Olympic icons—two thousand years and twenty years in one day.",
            ],
          },
          {
            title:
              "Day 4 | Summer Palace · Old Summer Palace · Drum Tower · Yandai Xiejie",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "[Stay Tip] Haidian/Xicheng border area, or Guohong Hotel (Metro Line 9 direct).",
              "Morning at Summer Palace—Long Corridor, Seventeen-Arch Bridge, Foxiang Pavilion on the hillside—the emperor's summer retreat, truly cool.",
              "Afternoon at Old Summer Palace (Yuanmingyuan)—focus on the Western Mansions ruins; Dashuifa stones still stand. One look says it all.",
              "Evening at Drum Tower and Yandai Xiejie—red walls, grey tiles, narrow lane of candied hawthorn and trinkets, Drum Tower shadow overhead.",
              "Royal gardens to ruins to lively hutong—all in one day.",
            ],
          },
          {
            title:
              "Day 5 | Lama Temple · Confucius Temple & Imperial College · Wudaoying Hutong",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "[Stay Tip] Near Lama Temple / Beixinqiao for walking access to sights.",
              "Morning at Lama Temple (Yonghegong)—incense, tall sandalwood Buddha, turn prayer wheels clockwise.",
              "Next door: Confucius Temple and Imperial College—stone tablets of scholars, glazed archway of the ancient academy.",
              "Evening in Wudaoying Hutong—quiet lanes, cafés behind grey brick walls. Sit with a drink and watch the street go by.",
              "From temple to academy to hutong café—a gentle cultural day.",
            ],
          },
          {
            title: "Day 6 | National Museum · Prince Gong's Mansion",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "[Stay Tip] Stay in Dongcheng for a relaxed last morning before departure.",
              'Morning at the National Museum of China—"Ancient China" from prehistory to Qing: famous bronzes, jade suits, treasures from textbooks.',
              "Afternoon at Prince Gong's Mansion—Heshen's former home, garden more refined than you might expect. Rub the Fu character stele for good luck.",
              "From national treasures to one family's elegance.",
            ],
          },
          {
            title: "Day 7 | Sleep In · Airport/Station Transfer · Departure",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "No alarm today. Wake naturally, breakfast slowly, pack, one last look at Beijing outside the window.",
              "Private transfer per your flight or train schedule. Flip through photos: flag-raising, Great Wall wind, hutong coffee, Forbidden City red walls…",
              "Beijing fades behind you. Seven days should live in memory now. Safe travels—welcome back anytime.",
            ],
          },
        ],
        feeIncluded:
          "Attraction tickets, hotels, meals, guide, and private transport listed in the itinerary.",
        feeExcluded:
          "International/domestic flights and taxes, personal travel/medical insurance, visa fees, personal expenses, and extra costs due to force majeure (flight delays, natural disasters, war, etc.).",
        feeRemarks: [
          "This itinerary is for reference during pre-trip planning only. Final itinerary and services are subject to our official Travel Confirmation Letter.",
          "If hotels are requisitioned due to force majeure, we will replace with same or higher standard properties. Final hotels are as stated on the official itinerary.",
        ],
      },
      {
        heroTag: "",
        heroTitle: "Meet Chang'an · 6-Day 5-Night Xi'an Private Custom Tour",
        tourTitle: '"From the City Wall to the City That Never Sleeps"',
        tourDesc:
          "6-Day 5-Night Xi'an Private Group | One Order One Group | No Ride-Sharing",
        tourRoute:
          "6 Days 5 Nights | Terracotta Army · Mount Hua · Hukou · Big Goose Pagoda · Night City",
        tourCode: "CT-XA-06",
        tourDays: "6 Days",
        tourCities: "Xi'an-Mount Hua-Hukou",
        tourAccommodation: "Moxy Hotel/Yu Hotel/Huashan Inn, etc.",
        highlights: [
          "1-on-1 customization: dedicated senior team throughout",
          "Premium transport: luxury business vehicle, private travel",
          "Curated stays: quality hotels + themed experiences",
          "In-depth experiences: unlock local hidden gems",
          "Chinese guide-driver: professional, zero language barrier",
          "Pure play guarantee: licensed operator, no shopping stops",
          "Worry-free service: one-stop planning, truly hassle-free",
        ],
        days: [
          {
            title:
              "Day 1 | Arrive in Xi'an · 24h Private Pickup · Hotel Check-in",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "[Stay Tip] Moxy Hotel Xi'an City Center.",
              "Check in with valid ID; standard check-in is after 14:00. Early arrivals may leave luggage at the front desk and explore nearby.",
              "Free time—recommended: Bell & Drum Tower Square, Muslim Quarter (optional).",
            ],
          },
          {
            title:
              "Day 2 | Qin & Tang · Terracotta Army · VR or Figurine DIY · Huaqing Palace",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "[Stay Tip] Yu Hotel (Xi'an Huaqing Palace).",
              "Morning at the Terracotta Army—8,000+ warriors, each face unique. Wireless headsets and guided tour; then choose VR film or make a mini figurine.",
              "Afternoon at Huaqing Palace—Tang imperial hot springs at the foot of Mount Li, water still flowing.",
              "Evening shows recommended: Eternal Love of Xi'an or Camel Bell Legend—grand scale, real camels, popular with international guests.",
              "Qin and Tang in one day.",
            ],
          },
          {
            title:
              "Day 3 | Summit Views · Breakfast · Mount Hua (energy pack included) · City Hotel",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "[Stay Tip] Huashan Inn.",
              "Morning to Mount Hua—one of China's most thrilling peaks, legendary in martial arts novels. Cable car up, cliff paths, waves of mountains at the summit. Energy pack included. Return to city hotel by evening—sore legs, worth it.",
            ],
          },
          {
            title:
              "Day 4 | Hukou Falls · Hotel Pickup · Hukou · Overnight Xi'an",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "[Stay Tip] Moxy Hotel Xi'an City Center.",
              "Morning pickup to Hukou Waterfall on the Yellow River—squeezed into a narrow gorge, spray dozens of meters high, thunder heard from afar. Mist on your face—you feel why the Yellow River is called the mother river: fierce yet awe-inspiring. Return to Xi'an in the evening.",
            ],
          },
          {
            title:
              "Day 5 | Back to Chang'an · Museum & Small Wild Goose Pagoda · Big Goose Pagoda · Hanfu · Night City",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "[Stay Tip] Moxy Hotel Xi'an City Center.",
              "Morning at Small Wild Goose Pagoda and Xi'an Museum—quiet old tower, stories of ancient Chang'an.",
              "Afternoon at Big Wild Goose Pagoda—where Xuanzang translated sutras; climb for city views.",
              "Hanfu and makeup—walk the streets like you stepped out of the Tang. Great for photos.",
              "Don't blink at night. Grand Tang Mall lights up, Hanfu everywhere, like a movie set. Pagoda fountain shoots with the music. Private transfer back—you're part of Chang'an's story today.",
            ],
          },
          {
            title: "Day 6 | Sleep In · Free Time · 24h Transfer · Departure",
            hotel: "",
            route: "",
            meals: "",
            paragraphs: [
              "[Stay Tip] Moxy Hotel Xi'an City Center.",
              "No alarm. Wake naturally, breakfast slowly.",
              "Your time—shop nearby, buy souvenirs, or flip through trip photos in the room.",
              "Private transfer per flight or train schedule. Xi'an fades behind you. Six days should live in your heart now. Safe travels—welcome back anytime.",
            ],
          },
        ],
        feeIncluded:
          "Attraction tickets, hotels, meals, guide, and private transport listed in the itinerary.",
        feeExcluded:
          "International/domestic flights and taxes, personal travel/medical insurance, visa fees, personal expenses, and extra costs due to force majeure (flight delays, natural disasters, war, etc.).",
        feeRemarks: [
          "This itinerary is for reference during pre-trip planning only. Final itinerary and services are subject to our official Travel Confirmation Letter.",
          "If hotels are requisitioned due to force majeure, we will replace with same or higher standard properties. Final hotels are as stated on the official itinerary.",
        ],
      },
    ],
  },
  strategy: {
    title: "Travel Tips",
    en: "PLAY GUIDE",
  },
  guide: {
    bcfw: {
      en: "CHARTER SERVICE",
      title: "Custom Charter · Private Travel",
      paragraphs: [
        "Private door-to-door transfers with no ride-sharing or detours—your schedule comes first. Local drivers who know the roads help you skip traffic and reach the heart of each sight. Water and charging cables on board; spacious comfort for seniors and children. No dragging luggage on the subway or waiting for taxis—seamless connections between attractions. Ideal for families, foreign guests, and small private groups: save time on the road for the scenery.",
      ],
    },
    cjly: {
      en: "HOTEL BOOKING",
      title: "Luxury Hotels · Private Privileges",
      paragraphs: [
        "We select Aman, Four Seasons, Ritz-Carlton and other luxury properties—each personally vetted. Family trips get kids' clubs; trips with seniors get elevators and nutritious meals; couples get private, stylish stays. From budget chains to boutique design, we match your budget and needs precisely. No late-night price comparisons or scrolling through hundreds of reviews—we pick for you, you just check in.",
      ],
    },
    gnly: {
      en: "TICKET BOOKING",
      title: "Ticket Booking · One Step Ahead",
      paragraphs: [
        "Lock tickets for popular attractions early—no more anxiety over midnight grabs. Forbidden City, Terracotta Army, Disney, Universal—we have channels for the hardest bookings. Skip ticket lines; enter with ID or QR code. Sold out, crowd limits, sudden closures? We rebook, refund, or find alternatives. Tickets in hand, travel anytime.",
      ],
    },
    qydz: {
      en: "CHINESE FLAVORS",
      title: "Signature Cuisine · Hard to Book",
      paragraphs: [
        "Peking duck, Xi'an paomo, Chengdu hotpot—authentic Chinese flavors, reserved for you. Quanjude, Da Dong, time-honored brands, Black Pearl—popular restaurants booked ahead, no queues. Private rooms, scenic tables, dietary needs—all arranged in advance. No rushing, no waiting, no regrets. Every meal across China, booked for you.",
      ],
    },
    qzbl: {
      en: "VISA SERVICE",
      title: "Visa Service · Worry-Free",
      paragraphs: [
        "Professional one-on-one guidance with a clear document checklist—no guessing, no repeat trips. Solutions for tough cases: blank passport, refusal history, difficult employment letters. Expedited channels, form filling, full translation—real-time progress tracking. From submission to approval, every step monitored. Leave the hassle to us; you prepare to depart.",
      ],
    },
    srdz: {
      en: "THEMED TRAVEL",
      title: "Themed Travel · Play Different",
      paragraphs: [
        "More than sightseeing—fulfilling a dream. Family study tours, honeymoon shoots, meditation retreats, food crawls, outdoor adventures—designed around your interests. Routes walked on site, local guides, hidden spots away from crowds. Itinerary, stays, and experiences all built around one theme. Deep immersion, not rushed tours.",
      ],
    },
  },
};
